<template>
  <div />
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'TrackerCarrotQuest',
    computed: {
      ...mapGetters(['account', 'config', 'member']),
      isEnabled() {
        return this.config.tracking && this.config.carrotQuest
      },
    },
    watch: {
      isEnabled: {
        immediate: true,
        handler() {
          if (this.isEnabled) {
            this.init()
          } else {
            this.destroy()
          }
        },
      }
    },
    methods: {
      init() {
        if (!window.carrotquest && this.isEnabled) {
          !function(){function t(t){return function(){window.carrotquestasync.push(t,arguments)}}var e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src="//cdn.carrotquest.io/api.min.js",document.getElementsByTagName("head")[0].appendChild(e),window.carrotquest={},window.carrotquestasync=[],window.carrotquest.settings={};for(var n=["connect","track","identify","auth","oth","onReady","addCallback","removeCallback","trackMessageInteraction"],a=0;a<n.length;a++)window.carrotquest[n[a]]=t(n[a])}(),window.carrotquest.connect(this.config.carrotQuest);
        }
      },
      identify() {
        if (window.carrotquest && this.isEnabled) {
          const {id, email, created} = this.account
          const {carrotHash} = this.member
          if (carrotHash) {
            window.carrotquest.auth(id, carrotHash)
            window.carrotquest.identify({$email: email, created})
          }
        }
      },
      track(goal, params) {
        if (window.carrotquest && this.isEnabled) {
          window.carrotquest.track(goal, params)
        }
      },
      destroy() {

      },
    },
    created() {
      this.$store.subscribeAction(({type, payload}) => {
        switch (type) {
          case 'socket_connect':
            this.identify()
            break
          case 'logout':
            this.destroy()
            break
          case 'goal':
            this.track(payload.goal, payload.params)
            break
        }
      })
    },
    beforeDestroy() {
      this.destroy()
    },
  }
</script>
